(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"), require("React"), require("ReactDOM"), require("History"), require("weaHrm"));
	else if(typeof define === 'function' && define.amd)
		define(["mobx", "React", "ReactDOM", "History", "weaHrm"], factory);
	else if(typeof exports === 'object')
		exports["weaHrm"] = factory(require("mobx"), require("React"), require("ReactDOM"), require("History"), require("weaHrm"));
	else
		root["weaHrm"] = factory(root["mobx"], root["React"], root["ReactDOM"], root["History"], root["weaHrm"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_662__, __WEBPACK_EXTERNAL_MODULE_664__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition